<!--  -->
<template>
  <div class="">
    <a-result
      status="success"
      title="二维码拍照保留，出示二维码验票方可入园"
      sub-title="如若多个参观者，请点击下方我的订单查看详情"
    >
      <template #extra>
        <div>
          <img :src="detail.qr_img" alt="" />
          <p>订单号：{{ detail.ordersn }}</p>
          <p>
            参观日期：{{ detail.use_date }}&nbsp;&nbsp;{{ detail.ticket_type }}
          </p>
        </div>
        <a-button key="console" type="primary" @click="order">
          我的订单
        </a-button>
        <a-button key="buy" @click="buy">
          再次预约
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import { getOrders } from "@/api/api-user";

export default {
  components: {},
  data() {
    return {
      detail: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {
      getOrders({ page: 1, status: 0 }).then(res => {
        this.detail = res.list[0];
      });
    },
    order() {
      this.$router.push("/order");
    },
    buy() {
      location.reload();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-result-extra {
  margin-top: 0;
}
</style>
